<template>
    <div data-component="stratmk.mobi-nav-menu.v12020" class="mobi-nav-menu max">
        <v-layout row wrap justify-center align-center>
            <v-card 
                flat
                color="transparent" v-for="(n, i) in navOpt" :key="i" class="nav-item fw" :to="{name: n.to}" @click="closeMenu(n.to)">
                <v-card-title class="n-title white--text font-weight-black justify-center pb-0 dolo" style="letter-spacing: -0px;">{{n.title}}</v-card-title>
                <v-card-text class="pt-2">
                    <v-layout justify-center>
                        <v-card flat height="1" width="30px" color="tertiary"></v-card>
                    </v-layout>
                </v-card-text>
            </v-card>
            <v-btn class="mt-6" small rounded outlined color="amber" @click="openReqDemo()">Request A Demo</v-btn>
        </v-layout>
        <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" v-model="reqDemoDialog">
            <v-card flat class="pa-6 overflow-hidden ">
                <demo-req @killReqDialog="killReqDialog()" />
            </v-card>
        </v-dialog>
        <mobi-footer />
    </div>
</template>

<script>
import mobiFooter from './mobi-footer'
import demoReq from '../views/demo_request'

export default {
    components: {
        mobiFooter,
        demoReq
    },
    props: {},
    data: () => {
        return {
            reqDemoDialog: false,
            navOpt: [
                {
                    title: 'Strategery.',
                    subtitle: 'What is it?',
                    to: 'home'
                },
                /* {
                    title: 'Investor Relations.',
                    subtitle: 'Join the next big thing.',
                    to: 'investor_relations'
                }, */
                /* {
                    title: 'Overview.',
                    subtitle: 'The Cheat Sheet.',
                    to: 'overview'
                }, */
            ]
        }
    },
     methods: {
        closeMenu(r){
            this.$emit('closeMenu', r)
            this.$emit('homeSection')
            //eslint-disable-next-line
            //console.log('nav-menu.methods.closeMenu -- ' +r)
        },
        openReqDemo() {
            this.reqDemoDialog = true
        },
        killReqDialog(){
            this.reqDemoDialog = false
        }
    }
}
</script>

<style lang="scss" scoped>

    $hover-color: #2BCDC9;

    .mobi-nav-menu {
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;
        padding-top: 20%;

        .nav-item {
            .n-title {
                letter-spacing: -55px;
                font-size: 18px;
            }
            .n-subtitle {
                color: white;
                font-size: 12px;
            }
        }
    }
</style>